import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import Layout from '../../views/layout/index.vue';
import { lazy } from 'react';
const inventoryMap = {
  path: '/inventorymap',
  name: 'inventoryMap',
  meta: {
    title: 'Inventory Map',
    icon: 'Inventory Map',
  },
  redirect: '/inventorymap/historical',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'historical',
      name: 'inventoryMap.historicaInventoryMap',
      meta: {
        title: 'Historical Inventory Map',
      },
      component: () =>
        import('../../views/inventory-map/historical-inventory-map/index.vue'),
    },
    {
      path: 'available',
      name: 'inventoryMap.availableInventoryMap',
      meta: {
        title: 'Available Inventory Map',
        filterSave: true,
      },
      component: () =>
        import('../../views/inventory-map/available-inventory-map/index.vue'),
    },
    {
      path: 'available/detail:sku_id',
      name: 'inventoryMap.availableInventoryMap.detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'inventoryMap',
            title: 'Inventory Map',
          },
          {
            routeName: 'inventoryMap.availableInventoryMap',
            title: 'Available Inventory Map',
          },
        ],
      },
      component: () => import('../../views/wms-basic/sku-items/sku/detail.vue'),
    },
    {
      path: 'onhand',
      name: 'inventoryMap.onHandInventoryMap',
      meta: {
        title: 'On-Hand Inventory Map',
        filterSave: true,
      },
      component: () =>
        import('@/views/inventory-map/on-hand-inventory-map/index.vue'),
    },
    {
      path: 'onhand/detail/:sku_id',
      name: 'inventoryMap.onHandInventoryMap.detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'inventoryMap',
            title: 'Inventory Map',
          },
          {
            routeName: 'inventoryMap.onHandInventoryMap',
            title: 'On-Hand Inventory Map',
          },
        ],
      },
      component: () => import('../../views/wms-basic/sku-items/sku/detail.vue'),
    },
    {
      path: 'expiry',
      name: 'inventoryMap.expiryAgingInventoryMap',
      meta: {
        title: 'Expiry & Aging Inventory map',
        filterSave: true,
      },
      component: () =>
        import('@/views/inventory-map/expiry-aging-inventory-map/index.vue'),
    },
    {
      path: 'expiry/detail/:sku_id',
      name: 'inventoryMap.expiryAgingInventoryMap.detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'inventoryMap',
            title: 'Inventory Map',
          },
          {
            routeName: 'inventoryMap.expiryAgingInventoryMap',
            title: 'Expiry & Aging Inventory Map',
          },
        ],
      },
      component: () => import('../../views/wms-basic/sku-items/sku/detail.vue'),
    },
    {
      path: 'transactionInventoryMap',
      name: 'inventoryMap.transactionInventoryMap',
      meta: {
        title: 'Transaction Inventory Map',
      },
      redirect: '/inventorymap/transactionInventoryMap/sku',
      component: () =>
        import('../../views/inventory-map/transaction-inventory-map/index.vue'),
      children: [
        {
          path: 'sku',
          name: 'inventoryMap.transactionInventoryMap.sku',
          meta: {
            title: 'SKU Transaction',
            menuHide: true,
          },
          component: () =>
            import(
              '../../views/inventory-map/transaction-inventory-map/components/sku-transaction.vue'
            ),
        },
        {
          path: 'batch',
          name: 'inventoryMap.transactionInventoryMap.batch',
          meta: {
            title: 'Batch Transaction',
            menuHide: true,
          },
          component: () =>
            import(
              '../../views/inventory-map/transaction-inventory-map/components/batch-transaction.vue'
            ),
        },
      ],
    },
    {
      path: 'av-inventory-map',
      name: 'inventoryMap.avinventorymap',
      meta: {
        title: 'AV Inventory Map',
      },
      redirect: '/inventorymap/av-inventory-map/sku',
      component: reactContainerFactory({
        name: 'inventoryMap.avinventorymap',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/inventory-map/av-inventory-map')
          ),
      },
      children: [
        {
          path: 'sku',
          name: 'inventoryMap.avinventorymap.sku',
          meta: {
            title: 'SKU AV Inventory',
            menuHide: true,
          },
        },
        {
          path: 'batch',
          name: 'inventoryMap.avinventorymap.batch',
          meta: {
            title: 'Batch AV Inventory',
            menuHide: true,
          },
        },
      ],
    },
    {
      path: 'blockInventoryMap',
      name: 'inventoryMap.blockInventoryMap',
      meta: {
        title: 'Block Inventory Map',
      },
      component: () =>
        import('../../views/inventory-map/block-inventory-map/index.vue'),
    },
    {
      path: 'unblockInventoryMap',
      name: 'inventoryMap.unblockInventoryMap',
      meta: {
        title: 'Unblock Log',
      },
      component: () =>
        import('../../views/inventory-map/unblock-inventory-map/index.vue'),
    },
    {
      path: 'instransitInventoryMap',
      name: 'inventoryMap.intransitInventoryMap',
      meta: {
        title: 'In-Transit Inventory Map',
      },
      component: () => import('@/views/inventory-map/intransit-map/index.vue'),
    },
    {
      path: 'zone_inventory_map',
      name: 'inventoryMap.zoneinventorymap',
      meta: {
        title: 'Zone Inventory Map',
      },
      component: () =>
        import('@/views/inventory-map/zone-inventory-map/index.vue'),
    },
    {
      path: 'skubatch',
      name: 'inventoryMap.skubatchinventorymap',
      meta: {
        title: 'SKU Batch Inventory Map',
      },
      component: reactContainerFactory({
        name: 'inventoryMap.skuBatchInventoryMap',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import('@/react-app/pages/inventory-map/sku-batch-inventory-map')
          ),
      },
    },
    {
      path: 'surplusandshortageinventorymap',
      name: 'inventoryMap.surplusandshortageinventorymap',
      meta: {
        title: 'Surplus/Shortage Inventory Map',
      },
      redirect: '/inventorymap/surplusandshortageinventorymap/surplus',
      children: [
        {
          path: 'surplus',
          name: 'inventoryMap.surplusandshortageinventorymap.surplus',
          meta: {
            title: 'Surplus Inventory Map',
            menuHide: true,
          },
        },
        {
          path: 'shortage',
          name: 'inventoryMap.surplusandshortageinventorymap.shortage',
          meta: {
            title: 'Shortage Inventory Map',
            menuHide: true,
          },
        },
        {
          path: 'surplustransaction',
          name: 'inventoryMap.surplusandshortageinventorymap.surplustransaction',
          meta: {
            title: 'Surplus Inventory Transaction Map',
            menuHide: true,
          },
        },
        {
          path: 'surplusshortagereconresult',
          name: 'inventoryMap.surplusandshortageinventorymap.surplusshortagereconresult',
          meta: {
            title: 'Surplus/Shortage Recon Result',
            menuHide: true,
          },
        },
      ],
      component: reactContainerFactory({
        name: 'inventoryMap.surplusandshortageinventorymap',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/inventory-map/surplus-shortage-inventory-map'
              )
          ),
      },
    },
    /* {
      path: 'available/:sku_id',
      name: 'availableInventoryMapDetail',
      meta: {
        title: 'detail',
        icon: '',
        menuHide: true,
        navList: [
          {
            routeName: 'inventoryMap',
            title: 'Inventory Map',
          },
          {
            routeName: 'availableInventoryMap',
            title: 'Available Inventory Map',
          },
        ],
      },
      component: () =>
        import(
          '@/views/inventory-map/available-inventory-map/detail/index.vue'
        ),
      }
    }, */
  ],
};

export default inventoryMap;
